module.exports = __webpack_public_path__ + "static/media/dog.b29f14a0.jpg";